var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMiaBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 297.661,
    height: 87.629,
    viewBox: "0 0 297.661 87.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-2",
    "data-name": "logo",
    transform: "translate(0 18.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15734",
    "data-name": "Trazado 15734",
    d: "M11860.032,13822.373V13766.4h-16.1l-27.321,44.192-27.4-44.192H11773.1v55.976h10.259v-46.342l28.521,46.342h9.376l28.521-46.342v46.342Z",
    transform: "translate(-11773.098 -13766.397)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15735",
    "data-name": "Trazado 15735",
    d: "M19304.1,13766.4v55.976h10.25V13766.4Z",
    transform: "translate(-19204.104 -13766.397)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15736",
    "data-name": "Trazado 15736",
    d: "M20739.826,13801.512h30.764l-15.381-26.672Zm42.863,20.861-6.969-12.1h-40.943l-6.969,12.1h-11.7l32.605-55.976h12.979l32.613,55.976Z",
    transform: "translate(-20597.375 -13766.397)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isotipo",
    transform: "translate(203.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15742",
    "data-name": "Trazado 15742",
    d: "M87.5,3.237c1.117.766,1.1.732,2.149,1.529,12.108,9.24,18.731,21.108,17.44,37.57a44.366,44.366,0,0,1-3.935,14.5c-4.988,11-14.289,18.5-27.105,23a.571.571,0,0,0-.375.527.68.68,0,0,0,.567.758,5.94,5.94,0,0,0,1.857-.334,42.463,42.463,0,0,0,23.17-18.48c8.255-13.7,9.036-28.746,2.677-41.642-2.558-5.187-6.512-9.692-11.3-13.97a34.478,34.478,0,0,0-6.219-4.244c-.631-.351-1.236-.7-1.857-1.022-.557-.288-.889-.5-1.694-.861a.885.885,0,0,0,.119.07c.7.361.878.47,1.569.85C85.1,1.793,86.985,2.886,87.5,3.237Z",
    transform: "translate(-18.618 -0.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15743",
    "data-name": "Trazado 15743",
    d: "M25.306,92.372c1.167,1.563,4.326,2.962,7.266,4.281,7.762,3.481,19.31,5.7,28.473,3.605,24.006-4.484,39.2-25.592,39.609-45.054C98.265,72.985,89.766,86.706,73.643,94.7c-16.063,7.96-32,6.593-47.848-2.763a.254.254,0,0,0-.071-.042.343.343,0,0,0-.372.1.344.344,0,0,0-.046.383Z",
    transform: "translate(-6.621 -13.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15744",
    "data-name": "Trazado 15744",
    d: "M97.152,53.982c.008-.019.021-.049.03-.07,4.522-11.709,4.558-22.69-1.861-33.721C88.367,8.242,77.423,2.38,63.665,1.545c12.793,1.632,23.4,7.112,30.114,18.319,6.559,10.937,6.363,22.109,1.877,34.216a.4.4,0,0,0,.108.4.788.788,0,0,0,.619.128,1.479,1.479,0,0,0,.709-.538A.5.5,0,0,0,97.152,53.982Z",
    transform: "translate(-15.762 -0.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15745",
    "data-name": "Trazado 15745",
    d: "M26.584,80.367C12.986,72.232,5.6,60.467,7,44.423,8.386,28.471,17.631,18.312,32.452,13.1a.475.475,0,0,0,.312-.438.566.566,0,0,0-.472-.631,4.944,4.944,0,0,0-1.545.278A35.336,35.336,0,0,0,11.461,27.694C1.827,43.68,4.626,62.57,18.514,74.983,20.9,77.117,23.88,78.588,26.584,80.367Z",
    transform: "translate(-1.982 -3.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15746",
    "data-name": "Trazado 15746",
    d: "M63.512,11.57c-.972-1.3-3.6-2.466-6.05-3.564-6.46-2.9-16.072-4.744-23.7-3C13.782,8.739,1.139,26.307.8,42.507c1.987-14.8,9.062-26.221,22.482-32.87,13.37-6.626,26.634-5.489,39.828,2.3a.211.211,0,0,0,.059.035.285.285,0,0,0,.348-.4Z",
    transform: "translate(-0.795 -1.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15747",
    "data-name": "Trazado 15747",
    d: "M13.814,41.675l-.024.056C10.03,51.479,10.4,61.09,15.743,70.27,21.529,80.214,30.35,85.423,41.8,86.117,31.153,84.76,22.616,79.87,17.026,70.542c-5.459-9.106-5.7-18.872-1.962-28.95a.332.332,0,0,0-.091-.335.656.656,0,0,0-.515-.106,1.227,1.227,0,0,0-.59.446A.443.443,0,0,0,13.814,41.675Z",
    transform: "translate(-3.295 -10.129)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiaBlanco);
export default __webpack_public_path__ + "static/media/logo-mia-blanco.6655999b680297fc50ff36a4f01e009e.svg";
export { ForwardRef as ReactComponent };